<template>
  <div>
    <div class="row text-white inner-row" style="background: #44927b">
      <div class="col-md-10" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b v-if="object.date">{{'Звонок от ' + convertDate(object.date) + ' : ' + fieldView(object.executorData ? object.executorData.name : "") + ' -> ' + fieldView(object.client.name)}}</b>
        <b v-else-if="object.projectDate">{{ `Плановый звонок ${convertDate(object.projectDate)} ` +  fieldView(object.executorData ? object.executorData.name : "-") + ' -> ' + fieldView(object.client.name)}}</b>
        <b v-else>{{'Звонок ' + fieldView(object.executorData ? object.executorData.name : "") + ' -> ' + fieldView(object.client.name)}}</b>
      </div>
      <div class="col-md-2" style="text-align: right">
        <i v-if="!object.date || (Date.now() - object.date) < 4.32e+7" class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>
    <simple-row :name="'Плановая дата звонка'" :value="convertDate(object.projectDate)"></simple-row>
    <simple-row :name="'Дата следующего звонка'" :value="convertDate(object.nextDate)"></simple-row>
    <simple-row :name="'Содержание звонка'" :value="fieldView(object.note)"></simple-row>
  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       object: this.item.object,
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     }
   }
 }
</script>
<style>
</style>
